'use strict';
var React = require('react');
var dataHelper = require('../../helper/dataHelper');
var util = require('../../helper/util');

/**
 * 显示处理多行文字
 */
var MultilineText = React.createClass({
  propTypes: {
    text: React.PropTypes.string.isRequired
  },

  render: function () {
    var text = dataHelper.decodeURIComponent(this.props.text.replace(/\+/g, '%20'));
    var remarkContent = {
      overflow:'hidden',
      height: '100%'
    };
    return (
      <div style={remarkContent} className="common-multi-line-text" >
        {text && text.split('\n').map(function (line, index) {
          if (line.trim()) {
            return <p key={index}>{util.Text.convertSpaceToNbsp(line)}</p>;
          }
          return <br key={index}/>;
        })}
      </div>
    );
  }
});

module.exports = MultilineText;


// WEBPACK FOOTER //
// ./src/views/common/MultilineText.jsx